import { isLocalhostEnvironment, isTestEnvironment, uuid } from './utils';
const BASE_AVATAR_SCALE_MULTIPLIER = 1.1;
const LOCALHOST_UNIQUE_AVATAR_OVERRIDDEN_USERNAMES = {
    p1: 'mystic',
    p2: 'monkey',
    p3: 'squirrel',
    p4: 'lizard',
    p11: 'queen',
    p12: 'wizard',
    p13: 'sentinel',
    p14: 'seer'
};
const LIVE_UNIQUE_AVATAR_OVERRIDDEN_PLAYER_IDS = {
    1: 'automaton',
    1592205: 'wizard', // kick_em
    1008506: 'muertos', // shpg706
    1086857: 'sentinel', // aimer
    143567: 'mystic', // TG_IVORY
    146875: 'seer' // grrrrrrrr
};
/**
 * Calculate a weighted average that favors one dimension's scale twice as much as the other,
 * so if the area for an avatar is very wide or very tall, the avatar can go a little outside
 * its strict bounds which looks better in "stretched" browser dimensions.
 */
export function getBaseAvatarScaleFactor(textureWidth, textureHeight, seatWidth, seatHeight) {
    const isConstrainedByHeight = textureHeight / textureWidth > seatHeight / seatWidth;
    const baseHeightScale = seatHeight / textureHeight;
    const baseWidthScale = seatWidth / textureWidth;
    const baseScale = isConstrainedByHeight
        ? (2 * baseHeightScale + baseWidthScale) / 3
        : (2 * baseWidthScale + baseHeightScale) / 3;
    return baseScale * BASE_AVATAR_SCALE_MULTIPLIER;
}
function getOverriddenUniqueAvatarType(playerId, username) {
    if (isLocalhostEnvironment()) {
        return username ? LOCALHOST_UNIQUE_AVATAR_OVERRIDDEN_USERNAMES[username] : undefined;
    }
    else {
        return playerId ? LIVE_UNIQUE_AVATAR_OVERRIDDEN_PLAYER_IDS[playerId] : undefined;
    }
}
/**
 * TEMPORARY!
 * This function allows for spiking on a unique avatar concept without making server changes.
 * For specific usernames/IDs, do a client-side override of the avatar to a unique image.
 * TODO: Update the server to fully support these and not do client-side overrides.
 */
export function maybeOverrideAvatar(playerId, username, defaultPlayerAvatar) {
    if (isTestEnvironment()) {
        return defaultPlayerAvatar;
    }
    const uniqueAvatarType = getOverriddenUniqueAvatarType(playerId, username);
    if (uniqueAvatarType) {
        return { type: 'unique', uniqueAvatarType, uuid: uuid() };
    }
    return defaultPlayerAvatar;
}
